export default __webpack_public_path__ + "static/media/google-play-badge-remove-preview.e85441a1.png";